/**
 * Created by swandelow on 09/03/18.
 */
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {TranslateModule} from '@ngx-translate/core';
import {CoreModule} from "../../core/core.module";
import {LogoutComponent} from "./logout.component";
import {LogoutRoutingModule} from "./logout-routing.module";
import {LogoutService} from "../../core/logout.service";

@NgModule({
    imports: [CommonModule, CoreModule, LogoutRoutingModule, TranslateModule],
    declarations: [
        LogoutComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    providers: [LogoutService]
})
export class LogoutModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/logout/logout.module.ts